/**
 * CreateChoiceDialog Component
 * Simple dialog prompting user to choose between creating a Shift or Task.
 * Shown when clicking an empty slot on the calendar.
 */

import { Users, ClipboardList } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

// ============================================================================
// Types
// ============================================================================

export interface CreateChoiceDialogProps {
  /** Whether the dialog is open */
  open: boolean;
  /** Called when dialog should close */
  onClose: () => void;
  /** Called when user chooses to create a Shift */
  onChooseShift: () => void;
  /** Called when user chooses to create a Task */
  onChooseTask: () => void;
}

// ============================================================================
// Component
// ============================================================================

export function CreateChoiceDialog({
  open,
  onClose,
  onChooseShift,
  onChooseTask,
}: CreateChoiceDialogProps) {
  const handleShiftClick = () => {
    onChooseShift();
  };

  const handleTaskClick = () => {
    onChooseTask();
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-xs">
        <DialogHeader>
          <DialogTitle className="text-center">Create New</DialogTitle>
        </DialogHeader>

        <div className="flex gap-3 justify-center py-4">
          {/* Canvassing Shift Button */}
          <Button
            variant="default"
            onClick={handleShiftClick}
            className="flex-1 flex-col gap-2 h-auto py-4"
          >
            <Users className="h-6 w-6" />
            <span>Canvassing Shift</span>
          </Button>

          {/* Task Button */}
          <Button
            variant="secondary"
            onClick={handleTaskClick}
            className="flex-1 flex-col gap-2 h-auto py-4"
          >
            <ClipboardList className="h-6 w-6" />
            <span>Task</span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CreateChoiceDialog;
